<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button
            @click="addTopicr"
            color="primary"
            type="border"
            icon-pack="feather"
            icon="icon-plus">
            Thêm chủ đề
          </vs-button>
        </div>
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery"
                  @input="updateSearchQuery" placeholder="Tìm kiếm..."/>
      </div>
      <!-- AgGrid Table -->
      <ag-grid-vue style="height: 55vh"
                   ref="agGridTable"
                   :components="components"
                   :gridOptions="gridOptions"
                   class="ag-theme-material w-100 my-4 ag-grid-table"
                   :columnDefs="columnDefs"
                   :defaultColDef="defaultColDef"
                   :rowData="topics"
                   :animateRows="true"
                   :pagination="true"
                   :paginationPageSize="20"
                   :onGridReady="onGridReady"
                   :suppressPaginationPanel="true">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="currentPage"/>
    </div>
  </div>
</template>

<script>
  import {AgGridVue} from "ag-grid-vue"
  import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'

  import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue"
  import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
  import moment from 'moment'

  export default {
    components: {
      AgGridVue,

      // Cell Renderer
      CellRendererStatus,
      CellRendererActions,
    },
    data() {
      return {
        searchQuery: "",
        maxPageNumbers: 6,
        // AgGrid
        gridApi: null,
        gridOptions: {},
        defaultColDef: {},
        columnDefs: [
          {
            headerName: 'Tên chủ đề',
            field: 'topicName',
            width: 150
          },
          {
            headerName: 'Từ khóa chính',
            field: 'keyword',
            width: 150,
          },
          {
            headerName: 'Từ khóa phụ',
            field: 'action',
            width: 250
          },
          // {
          //   headerName: 'Tên Nhóm',
          //   field: 'groupName',
          //   width: 150
          // },
          {
            headerName: 'Ngày tạo',
            field: 'createdDate',
            width: 100
          },
          {
            headerName: 'Hành động',
            field: 'transactions',
            width: 80,
            cellRendererFramework: 'CellRendererActions',
          },
        ],
        // Cell Renderer Components
        components: {
          CellRendererStatus,
          CellRendererActions,
        },
        topics: []
      }
    },
    created() {
      this.initScreen();
    },
    watch: {
      '$store.state.windowWidth'(val) {
        if (val <= 1024) {
          this.maxPageNumbers = 5;
        } else {
          this.maxPageNumbers = 7;
        }

        if (val > 1024) {
          this.gridApi.sizeColumnsToFit();
        }
      },
      '$store.state.reduceButton'() {
        setTimeout(() => {
          this.gridApi.sizeColumnsToFit();
        }, 650);
      },
      '$store.state.isUpdateUser'(val) {
        if (val) {
          this.initScreen();
          this.$store.commit('UPDATE_USER_SUCCESS', false);
        }
      },
    },
    computed: {
      totalPages() {
        if (this.gridApi) return this.gridApi.paginationGetTotalPages();
        else return 0
      },
      currentPage: {
        get() {
          if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
          else return 1
        },
        set(val) {
          this.gridApi.paginationGoToPage(val - 1)
        }
      }
    },
    methods: {
      updateSearchQuery(val) {
        this.gridApi.setQuickFilter(val)
      },
      addTopicr() {
        this.$router.push('/user/topic/add').catch(() => {
        })
      },
      onGridReady() {
        if (this.$store.state.windowWidth <= 1024) {
          this.maxPageNumbers = 5;
        } else {
          this.maxPageNumbers = 7;
        }

        if (this.$store.state.windowWidth > 1024) {
          this.gridApi.sizeColumnsToFit();
        }
      },
      getTopic(that) {
        return new Promise(function (resolve, reject) {
            let conditions = {};
            that.$business.post('/topic/find-by-conditions', conditions).then((topics) => {
              resolve(topics.data);
            }).catch((err) => {
              reject(err);
            });
          }
        );
      },
      getUser(that) {
        return new Promise(function (resolve, reject) {
          that.$oauth.post('/user/organization/all').then((users) => {
            resolve(users.data);
          }).catch((err) => {
            reject(err);
          });
        })
      },
      getGroupTopic(that) {
        return new Promise(function (resolve, reject) {
          that.$business.post('topic-group/find-by-conditions').then((topicGroup) => {
            resolve(topicGroup.data);
          }).catch((err) => {
            reject(err);
          });
        });
      },
      async initScreen() {
        try {
          this.$vs.loading();
          let topics = await this.getTopic(this);
          let users = await this.getUser(this);
          let topicGroups = await this.getGroupTopic(this);
          topics.forEach(topic => {

            let user = users.find(user => user.id == topic.userId);
            if (users) topic.fullName = user.fullName;

            let topicGroup = topicGroups.find(topicGroup => topicGroup.userId == topic.userId)
            if (topicGroup) topic.groupName = topicGroup.groupName;

            let keyWords = topic.keywords;
            if (keyWords) {
              let lstKeyWord = keyWords;
              topic.keyword = "",
              topic.action = "";
              lstKeyWord.forEach(keyWord => {
                topic.keyword += keyWord.keyword + ", ";
                if(keyWord.action.length > 0){
                topic.action += keyWord.action.join(", ") + ", ";
                }
              });
              topic.keyword = topic.keyword.slice(0, topic.keyword.length - 2);
              topic.action = topic.action.slice(0, topic.action.length - 2);
            }
            topic.createdDate = topic.createdDate ? moment(topic.createdDate).format("DD/MM/YYYY") : moment(topic.modifiedDate).format( "DD/MM/YYYY");
          });
          this.topics = topics;
          this.$vs.loading.close();
          setTimeout(() => {
            if (this.$store.state.windowWidth > 1024) {
              this.gridApi.sizeColumnsToFit();
            }
          }, 100);
        } catch (err) {
          this.$vs.loading.close();
          return this.$vs.notify({
            text: err.response.message || err.response.error_description || err.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        }
      }
    },
    mounted() {
      this.gridApi = this.gridOptions.api;
    }
  }
</script>

<style scoped>

</style>
